import _regeneratorRuntime from "babel-runtime/regenerator";

var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

import { gapi, loadAuth2WithProps } from "gapi-script";

var CLIENT_ID = "1043917107049-9j2t9sa1665pbj13vupthd7jbif63ia8.apps.googleusercontent.com";
var API_KEY = "AIzaSyBoYGCBVfCuAlEcpK_zsbn_ClHdwHuUwuQ";

var DISCOVERY_DOCS = ["https://sheets.googleapis.com/$discovery/rest?version=v4"];
var SCOPES = "https://www.googleapis.com/auth/spreadsheets.readonly";

var parseUser = function parseUser(user) {
  return !user.getId ? user : {
    id: user.getId(),
    name: user.getName(),
    givenName: user.getGivenName(),
    familyName: user.getFamilyName(),
    imageUrl: user.getImageUrl(),
    email: user.getEmail()
  };
};

export default {
  login: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var authData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return gapi.auth2.getAuthInstance().signIn();

            case 2:
              authData = _context.sent;
              return _context.abrupt("return", Promise.resolve({
                authData: authData.getAuthResponse(),
                user: parseUser(authData.getBasicProfile())
              }));

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function login() {
      return _ref.apply(this, arguments);
    };
  }(),
  logout: function logout() {
    return gapi.auth2.getAuthInstance().signOut();
  },
  checkAuth: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var auth2, currentUser;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return loadAuth2WithProps({
                apiKey: API_KEY,
                clientId: CLIENT_ID,
                discoveryDocs: DISCOVERY_DOCS,
                scope: SCOPES
              });

            case 2:
              auth2 = _context2.sent;

              if (!auth2.isSignedIn.get()) {
                _context2.next = 6;
                break;
              }

              currentUser = auth2.currentUser.get();
              return _context2.abrupt("return", Promise.resolve({
                authData: currentUser.getAuthResponse(),
                user: parseUser(currentUser.getBasicProfile())
              }));

            case 6:
              return _context2.abrupt("return", Promise.reject(new Error("checkAuth error")));

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function checkAuth() {
      return _ref2.apply(this, arguments);
    };
  }(),
  checkError: function checkError(error) {
    var status = error.status;
    if (status === 401 || status === 403) {
      return Promise.reject();
    }
    return Promise.resolve();
  },
  getPermissions: function getPermissions() {
    return Promise.resolve();
  }
};